import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import Icon from "../../Icon";
import Pill from "../../Pill";
import TableCellActions from "../TableCellActions";

const generateCellId = (id) => `proposal-transition-${id}`;

// eslint-disable-next-line sonarjs/cognitive-complexity
const TableCell = ({ column, row }) => {
  if (!column.key || !row) return null;

  const dateData = row.convertedDateTime?.split("|") || [];
  const dateString = dateData[0]?.trim();
  const timeString = dateData[1]?.trim();

  const proposalId = row.proposalId || row.transitionId;
  //! create a custom hook to define what the page based in the params
  const isProposalListingPage = row.transitionId;
  const isClientQuestionnaireListingPage = !row.transitionId;

  let linkTo = null;
  if (isClientQuestionnaireListingPage) {
    linkTo = proposalId
      ? `/reports/${proposalId}`
      : `/client-questionnaires/${row.questionnaireId}`;
  } else if (isProposalListingPage) {
    linkTo = `/proposals/${proposalId}`;
  }

  switch (column.key) {
    case "status":
      return (
        <td role="gridcell">
          <Pill text={row.status.text} type={row.status.type} />
        </td>
      );
    case "report":
      return (
        <td className="report" role="gridcell">
          {row.status?.type === "ready" ? (
            <div className="table__cell__wrapper">
              <Link
                to={`/reports/${proposalId}`}
                target="_blank"
                rel="noreferrer"
                className="table__cell__link"
                aria-labelledby={generateCellId(row.reportId)}
              >
                View {row.reportId}
                <Icon name="system-arrow-up-right" />
              </Link>
            </div>
          ) : (
            "Not Ready"
          )}
        </td>
      );
    case "actions":
      return (
        <td role="gridcell">
          <TableCellActions row={row} />
        </td>
      );
    case "name":
      return (
        <td role="gridcell">
          <div className="table__cell__wrapper">
            {linkTo ? (
              <Link
                to={linkTo}
                id={generateCellId(proposalId)}
                className="table__cell__link proposal-name"
              >
                {row[column.key]}
                <Icon name="system-chevron-right-large" />
              </Link>
            ) : (
              <div className="table__cell-empty">
                {row[column.key] ? row[column.key] : "-"}
              </div>
            )}
          </div>
        </td>
      );
    case "date":
      return (
        <td role="gridcell">
          {dateString && timeString ? (
            <>
              <p className="table__cell__wrapper date">{dateString}</p>
              <p className="table__cell__wrapper time">{timeString}</p>
            </>
          ) : (
            <p className="table__cell__wrapper">{row[column.key]}</p>
          )}
        </td>
      );
    case "reportName":
      return (
        <td role="gridcell">
          <a
            target="_blank"
            className="table__cell__link"
            href={row.reportLink}
            rel="noreferrer"
          >
            {row.reportName}
          </a>
        </td>
      );
    default:
      return (
        <td role="gridcell">
          <span className="table__cell__wrapper proposal-default">
            {row[column.key]}
          </span>
        </td>
      );
  }
};

TableCell.propTypes = {
  column: PropTypes.object,
  row: PropTypes.object,
};

export default TableCell;
